import React, { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';
import useResponsive from 'hooks/useResponsive';
import { Text } from '@/components/Typography';
import Typed from 'typed.js';

const Heading = () => {
  const { isMobile } = useResponsive();
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ['Semua Ekosistem IDN'],
      typeSpeed: 50,
      backSpeed: 50,
      backDelay: 1500,
      startDelay: 500,
      loop: true,
      loopCount: Infinity,
      smartBackspace: true,
      showCursor: false
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);



  return (
    <Box padding={isMobile ? '40px 24px' : '60px 40px 40px 80px'} data-testid="heroImage_heading" width="fit-content">
      <Text data-testid="heroImage_heading_top" variant={isMobile ? 'headingBold20' : 'headingBold32'} color="white">
        Satu Akun untuk
      </Text>
      <Box
        width="fit-content"
        borderRadius={isMobile ? '4px' : '8px'}
        background="linear-gradient(270deg, #627180 -2.43%, #14171A 73.59%)"
      >
        <Text data-testid="heroImage_heading_bottom" variant={isMobile ? 'headingBold20' : 'headingBold32'} color="white" margin="2px 8px">
          <span ref={el}></span>
        </Text>
      </Box>
    </Box>
  );
};

export default Heading;
